
import triangles from "../../../images/preciTriangles.svg"

export const LoginPageStyles = {
        backgroundImage: `url(${triangles})`,
        height: "100vh"
    }
export const LoginCardStyles = {
        height: "300px",
        width: "350px",
        margin: "auto",
        backgroundColor: "#df7a00",
        opacity: 0.85
    }
export const LogoStyles = {
        height: "150px",
        marginTop: "10px",
        marginBottom: "20px",
    }